import { bankEndPoint } from "./base.config";

export const bankServices = {
  getTransactionInfo: `${bankEndPoint}/api/bank-template/get-transaction-info`,
  getBalanceInfo: `${bankEndPoint}/api/bank-template/get-balance-info`,
  updateZtlBalance: `${bankEndPoint}/api/v2/ztl/account-balance/:id`,
}